module.exports = __webpack_public_path__ + "static/media/ad2.a00e6edc.png";